import { render, staticRenderFns } from "./BiddingDetail.vue?vue&type=template&id=683b3066&scoped=true"
import script from "./BiddingDetail.vue?vue&type=script&lang=js"
export * from "./BiddingDetail.vue?vue&type=script&lang=js"
import style0 from "./BiddingDetail.vue?vue&type=style&index=0&id=683b3066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b3066",
  null
  
)

export default component.exports